module.exports = __webpack_public_path__ + "img/download-thumb-2.9a250a5d.png";